import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api, ApiError, type Me } from './api';

/** The session: the user and their balances, or null when signed out. main.tsx starts it before
 *  the first render, alongside the screen's own data (lib/prefetch.ts). */
export const meQuery = {
  queryKey: ['me'] as const,
  queryFn: async (): Promise<Me | null> => {
    try {
      return await api<Me>('/me');
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) return null;
      throw e;
    }
  },
  staleTime: 15_000,
  // A country closed to the member (components/CountryGate) answers the same on a retry.
  retry: (count: number, e: unknown) =>
    !(e instanceof ApiError && e.code === 'COUNTRY_BLOCKED') && count < 1,
};

export function useMe() {
  return useQuery({ ...meQuery, refetchInterval: 30_000 });
}

export function useRefreshMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['me'] });
}

const REF_KEY = 'gp_ref';
export function rememberReferral(code: string) {
  try {
    localStorage.setItem(REF_KEY, code.slice(0, 32));
  } catch {
    /* storage unavailable */
  }
}
export function storedReferral(): string | undefined {
  try {
    return localStorage.getItem(REF_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}
